import { createSlice } from "@reduxjs/toolkit";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  formFilter: {
    programCode: string[];
    hrManagerCode: string[];
    fromDate: string;
    toDate: string;
  };
  events?: any[];
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  formFilter: {
    programCode: [],
    hrManagerCode: [],
    fromDate: "",
    toDate: "",
  },
  events: [],
};

const formFilterSlice = createSlice({
  name: "formFilterEventInterviewSchedule",
  initialState,
  reducers: {
    updateFormFilter: (state, action) => {
      Object.assign(state.formFilter, action.payload);
    },
    getEventsStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getEventsSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.events = action.payload.data;
    },
    getEventsFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetFormFiler: () => ({ ...initialState }),
  },
});

export const {
  updateFormFilter,
  resetFormFiler,
  getEventsStart,
  getEventsSuccess,
  getEventsFailed,
} = formFilterSlice.actions;

export default formFilterSlice.reducer;
